import { render } from "./DescInicial.vue?vue&type=template&id=120d1a76"
import script from "./DescInicial.vue?vue&type=script&lang=js"
export * from "./DescInicial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__